module.exports = __webpack_public_path__ + "static/img/phbanner.41cd8fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/phbanner.png
// module id = PSek
// module chunks = 2 9